import { gql } from '@apollo/client';

/**
 * Generic broker for smallapp microservice action buttons declared in manifests
 * (Refresh Data, Test Connection, Force Sync, Validate, etc.). Open-api signs the
 * service-to-service token the microservice requires; the frontend only holds a
 * Firebase JWT which smallapp microservices do not accept.
 *
 * See `AssetService.smallappProxyAction` (open-api) for the server-side contract.
 */
export const SMALLAPP_PROXY_ACTION = gql`
  mutation SmallappProxyAction(
    $assetId: String!
    $endpoint: String!
    $method: String
    $body: JSONObject
  ) {
    smallappProxyAction(assetId: $assetId, endpoint: $endpoint, method: $method, body: $body)
  }
`;

export interface SmallappProxyActionResult {
  smallappProxyAction: unknown;
}

export interface SmallappProxyActionVariables {
  assetId: string;
  endpoint: string;
  method?: 'GET' | 'POST' | 'PUT';
  body?: Record<string, unknown>;
}
